import { TextbitElement, type Descendant, type TBElement } from '@ttab/textbit'
import { parse } from 'node-html-parser'
import { Node } from 'slate'

export interface TableRowElement {
  type: 'core/table/row'
  class: 'block'
  children: [{
    type: 'core/table/row/cell'
    class: 'text'
    children: [{ text: string }]
  }]
}

export function parseTableRows(tablebody: string) {
  const root = parse(tablebody)
  const rows = root.querySelectorAll('tr')

  return rows.map((row) => {
    const cells = row.children

    // Handle empty rows, will be displayed a 'unknown object'
    if (cells.length === 0) {
      return {
        type: 'core/table/row/error',
        class: 'block',
        children: [{ text: '' }]
      }
    }

    return {
      type: 'core/table/row',
      class: 'block',
      children: cells.map((cell) => {
        const element: TBElement = {
          type: 'core/table/row/cell',
          class: 'text',
          children: [{ text: cell.textContent.trim() }]
        }

        const colspan = cell.getAttribute('colspan')
        const rowspan = cell.getAttribute('rowspan')

        if (colspan || rowspan) {
          element.properties = {
            ...(colspan ? { colspan } : {}),
            ...(rowspan ? { rowspan } : {})
          }
        }

        return element
      })
    }
  })
}

export function revertTableRows(data: Descendant[]) {
  return (data as TBElement[]).filter((d) => d.type === 'core/table/row')
    .map((d) => {
      const cells = ((d).children as TBElement[])
        .map((cell) => {
          if (!TextbitElement.isElement(cell)) {
            return '<td></td>'
          }

          const props = cell.properties as Record<string, string>
          const attribs = [
            props?.colspan ? `colspan="${props.colspan}"` : '',
            props?.rowspan ? `rowspan="${props.rowspan}"` : ''
          ].filter(Boolean).join(' ')

          return `<td${attribs ? ' ' + attribs : ''}>${Node.string(cell)}</td>`
        })
        .join('')
      return `<tr>${cells}</tr>`
    })
    .join('')
}
